module.exports = {
    toLogin: {
        loginTip: 'Login prompt',
        ifToLogin: 'Whether to go to the login',
        canel: 'Cancel',
        confirm: 'Ok',
        token:'Login expired, please login again',
    },
    DataSatName:{
        name1:'Global Ocean Vortex',
        name2:'Locust plague in the deserts of Asia and Africa',
        name3:'Global Ocean Vortex'
    },
    banner:{
        title:'Big Earth Data for SDGs',
        text1:'Digital connections, shared prosperity, for our people, for our planet.',
        text2:' Big earth data-driven innovations towards the Sustainable Development Goals, for a better world.',
    },
    // 导航菜单
    Nav: {
        // Name: 'DBAR Big Earth Data System',
        Name: 'DBAR Big Earth Data Analysis and Decision Support System',
        Menu: {
            Home: 'Home',
            DataHub: 'Data Hub',
            Story: 'SDGs Story',
            Featured: 'Featured News',
            Society: 'SDGs and Society',
            Science: 'Science for SDGs',
            Practices: 'Best Practices',
            AppsMarket: 'Apps Market',
            Knowledgebase: 'Knowledge Base',
            MySpace: 'My Space',
            AboutUs: 'About',
            Contact: 'Contact Us',
            SDG: 'About CBAS',
            Language: 'Language',
            ZH: 'Chinese',
            EN: 'English',
            Indicators: 'Indicators',
            Reports: 'Reports',
            UnderDevelopment: 'Under development',
        },
        User: {
            Login: 'Login',
            Logout: 'Logout'

        }
    },
    Index: {
        Technology: {
            latest: 'Latest'
        },
        Knowledge: {
            Indicators: 'Indicators',
            Reports: 'Reports',
            TerraViewSDGs: 'TerraView-SDGs'
        }
    },
    DataSerch: {
        key: 'Recommend Word',
        dataSearch: 'Data Search',
        filter: 'Filter criteria',
        geosphere: 'Geosphere',
        format: 'Format',
        source: 'Source',
        more: 'More',
        sort: 'Sort by',
        defaultSort: 'Default sort',
        visits: 'Visits',
        downloads: 'Downloads',
        lastUpdated: 'Last updated',
        browsingData: 'Browse Data',
        noData: 'No data',
        found: 'related results for you',
        Prefix: 'Found',
        Collected: 'Collected'
    },
    DataServer: {
        sdg1: 'NO POVERTY',
        sdg2: 'ZERO HUNGER',
        sdg3: 'GOOD HEALTH AND WELL-BEING',
        sdg4: 'QUALITY EDUCATION',
        sdg5: 'GENDER EQUALITY',
        sdg6: 'CLEAN WATER AND SANITATION',
        sdg7: 'AFFORDABLE AND CLEAN ENERGY',
        sdg8: 'DECENT WORK AND ECONOMIC GROWTH',
        sdg9: 'INDUSTRY、INNOVATION AND INFRASTRUCTURE',
        sdg10: 'REDUCED INEQUALITIES',
        sdg11: 'SUSTAINABLE CITIES AND COMMUNITIES',
        sdg12: 'RESPONSIBLE CONSUMPTION AND PRODUCTION',
        sdg13: 'CLIMATE ACTION',
        sdg14: 'LIFE BELOW WATER',
        sdg15: 'LIFE ON LAND',
        sdg16: 'PEACE、JUSTICE AND STRONG INSTITUTIONS',
        sdg17: 'PARTNERSHIPS FOR THE GOALS',
        sharingPlatform: 'Distributed Sharing Platform',
        platformStatistics: 'Data Access Statistics',
        tagCloud: 'Tag Cloud',
        mostPopular: 'Most Popular Area',
        dataClassification: 'Data Classification',
        topDataRanking: 'Top Data Rankings',
        noData: 'No data',
        recentUpdates: 'Recent Updates',
        dataVolume: 'Data volume',
        numberfiles: 'Number of files',
        views: 'Views',
        downloads: 'Downloads',
    },
    MySpace: {
        downloadNum: 'Download number',
        dataReserve: 'Data reservation',
        shopping: 'Shopping cart',
        collectNum: 'Collection number',
        dataOrder: 'Data orders',
        dataCollection: 'Data collection',
        batchReserve: 'Batch reservation',
        batchDelete: 'Batch delete',
        reserve: 'Reservation',
        delete: 'Delete',
        dataSatName: 'Data set name',
        dataID: 'Data ID',
        createTime: 'Creation time',
        Operation: 'Operation',
        orderNum: 'Order number',
        orderStatus: 'Order status',
        dataSize: 'Data size',
        orderTime: 'Order time',
        seen: 'View',
        thumbnail: 'Thumbnail',
        canelCollect: 'Cancel collection',
        collectTime: 'Collection time',
        Finish: 'Finish',
        inPreparation: 'In preparation',
        ftp: {
            projectName: 'Task Name',
            orderNum: 'Order Number',
            status: 'Status',
            adrees: 'FTP address',
            FTPusername: 'FTP username',
            FTPpassword: 'FTP password',
            applicationNotes: 'App notes',
            dataSatName: 'Datasat name',
            dataSize: 'Datasat size',
            dataId: 'DataId',
            createTime: 'Create time',
        },
        tip: {
            deleteSelectFile: 'Sure to delete the selected dataset file?',
            downloadTheFile: 'Sure to download the file?',
            deleteTheFile: 'Sure to delete the file?',
            dataReservation: 'Reservation data',
            projectName: 'Task name',
            applicationNotes: 'App notes',
            download: 'Download',
            cancel: 'Cancel',
            confirm: 'Confirm',
            seleteDataEntry: 'Please select a data entry',
            PleaseFill: 'Please fill in the relevant information',
            reservationSuccess: 'Data reservation success',
            deleteSelectOrder: 'Sure you want to delete the selected order?',
            deleteTheOrder: 'Are you sure you want to delete this order?',
            order: 'Order information',
            delete: 'Delete',
            orderNum: 'Order number',
            status: 'Status',
            adrees: 'FTP address',
            FTPusername: 'FTP username',
            FTPpassword: 'FTP password',
            uncollectSelectDatasat: 'Sure you want to uncollect the selected dataset?',
            uncollecttheDatasat: 'Sure you want to uncollect this dataset?',
        }
    },
    DataDetails: {
        Description: 'Shared within the project, do not support the download',
        Use: 'Use',
        Present: 'Present',
        NotPresent: 'Not present',
        tip: {
            dataEntry: 'Please select a data entry',
            successfully: 'Data added successfully',
            collectSuccessfully: 'Dataset Collection Success',
            failure: 'Please contact the administrator if you have failed to add data！',
            downloadData: 'Determine the current data to download?',
            cancel: 'Cancel',
            confirm: 'Confirm'
        },
        collectionDatasets: 'Collection Datasets',
        dataHub: 'Data Hub',
        dataContributors: 'Data Contributors',
        latestUpdate: 'Latest Update',
        storageVolume: 'Storage Volume',
        visits: 'Visits',
        downloads: 'Downloads',
        mateInfo: {
            sharing1: 'Private share',
            sharing2: 'Public share',
            basicInformation: 'Basic Information',
            productNumber: 'Product Number',
            dataType: 'Data Type',
            dataFormat: 'Data Format',
            Projection: 'Projection',
            startDate: 'Start Date',
            endDate: 'End Date',
            spatialResolution: 'Spatial Resolution',
            timeResolution: 'Time Resolution',
            geographicalScope: 'Geographical Scope',
            sharingMethod: 'Sharing Method',
            createInstitution: 'Create Institution',
            createdBy: 'Create dBy',
            creationDate: 'Creation Date',
            dataLabel: 'Data Label',
            sdgGoal: 'SDGs Goal',
            processingMethod: 'Processing Method',
            QuoteAddress: 'Quote Address',
            copyrightNotice: 'Copyright Notice',
            subProjectNumber: 'Sub-Project Number',
            dataObject: 'Data Object',
            dataIdentification: 'Data Identification',
            Description: 'Description',
            subjectClassification: 'Subject Classification',
            format: 'Format',
            scopeDescription: 'Scope Description',
            releaseAgency: 'Release Agency',
            Email: 'Email',
            Phone: 'Phone',
            latestRelease: 'Latest Release Date',
            totalStorage: 'Total Storage',
            totalFiles: 'Total Files',
            dateScope: 'Date Scope',
            resolution: 'Resolution',
            copyright: 'Copyright',
            creatingInformation: 'Creating Information',
            releaseNews: 'Release News',
            updateDate: 'Update Date',
            fileInformation: 'File Information',
            productType: 'Product Type',
        },
        close: 'Close',
        metadataDetails: 'Metadata Details',
        downloadMetadata: 'Download Metadata',
        relatedResources: 'Related Resources',
        localFiles: 'Local Files',
        serviceRecord: 'Service Record',
        relatedDocuments: 'Related Documents',
        addCart: 'Current selection add to cart',
        spaceLocation: 'Space Location',
        lookOtherData: 'People who viewed the data also viewed',
        relatedRecommendations: 'Related Recommendations',
        noData: 'No data'
    },
    DataHub: {
        NotDownload: 'Download is not supported',
        Filter: 'Filter',
        Services: 'Data services',
        Key: 'Keyword',
        Search: 'Search',
        TopSearch: 'Top search',
        Select: 'Used filters',
        Goal: 'SDGs Goal',
        Format: 'Format',
        Keywords: 'Keywords',
        Source: 'Source',
        Close: 'Close',
        Clear: 'Clear',
        All: 'Select All ',
        Mechanism: 'Release mechanism',
        Date: 'Create time',
        MoreData: 'Scroll down to load more',
        NoData: 'No more data available'

    },

    DataInfo2: {
        IdentityInformation: 'Identity information',
        Id: 'Identifier',
        Key: 'Keyword',
        provider: 'Provider',
        DataType: 'Data type',
        Source: 'Data source',
        DataSetFormat: 'Data format',
        ReleaseDate: 'Release date',
        DataSetDescriptionInformation: 'Data description information',
        DataSetName: 'Data name',
        GeographicPosition: 'Geographical location',
        SpatialReference: 'Spatial reference system',
        Spatial: 'Spatial resolution',
        DistributeandAccessInformation: 'Distribute and access information',
        ContactName: 'Contact name',
        Phone: 'Phone',
        Email: 'E-mail',
        Address: 'Address',
        PostCode: 'PostCode',
        Permission: 'Permission',

    },
    DataInfo: {
        Overview: 'Overview',
        File: 'Local file',
        Map: 'Map',
        Introduction: 'Data introduction',
        Address: 'Citation address',
        Basic: 'Basic information',
        Start: 'Start Date',
        End: 'End Date',
        Spatial: 'Spatial resolution',
        Temporal: 'Temporal resolution',
        Territorial: 'Territorial scope',
        Share: 'Sharing mode',
        Public: 'Public share',
        Copyright: 'Copyright:  This data may be used free of charge for academic and other non-commercial purposes only. It may not be redistributed or used for commercial purposes without prior permission. Users using this product should clearly identify the source and author.',
        Development: 'Under Development',
        CreateDate: 'Create date',
        fileNmu: 'File size',
        seeNum: 'Views',
        download: 'Downloads',
        downloadBtn: 'Download',
        otherData: 'Other data',
        Recommend: "Related recommendation",
        Operation: 'Operation'
    },
    App: {
        ExternalApp:'External Application',
        app9:'Integrated Decision Support Platform for Sustainable Development in Hainan Province',
        app5: 'Global Agricultural Remote Sensing Monitoring Cloud Platform',
        app6: 'Natural and Cultural Heritage Monitoring and Assessment System',
        app7: 'Remote sensing real-time monitoring system for engineering projects',
        app8: '国际灾害数据库数据自动获取模块',
        Market: 'Apps Market',
        welcome: 'Welcome to the big earth data system application market!',
        SDGs: 'Based on the 17 goals of SDGS, the system takes the global statistical data of the World Bank, WHO, the United Nations, Wikipedia and other organizations as the data source. By analyzing the index system of Sustainable Development Goals, the analysis and preprocessing of various data products and the fusion calculation of multi-source data are completed, and the quantitative evaluation and multi-dimensional visualization of SDGs indicators are realized.',
        SatEYE: 'Based on multi-source spatial information, the system can achieve an integrated digital representation of key elements, phenomena and their changing processes, such as natural resources, ecological environment, climate change and disasters, and social economy along the Belt and Road. On the web side, the system supports interactive display and realizes browsing, inquiry, statistics, mapping and other functions of various key elements, so as to provide more convenient data display and sharing application for the Belt and Road region.',
        Fire: 'The system, through analysis of satellite data, application of fire site monitoring algorithm and fire spread model, realizes the normal monitoring of fire site and, the discovery, verification and treatment of fire situation.',
        COVIDTracker: 'The system, through the collection of epidemic data, public-opinion data, socio-economic data and environmental data, and the application of epidemic prediction models and personnel migration models, realizes the visualization of epidemic increase and distribution and the prediction of epidemic development trend, so as to provide effective support for epidemic detection, transmission prediction and risk assessment.',
        app0:'Based on the sustainable development baseline database of Hainan Province, integrating the comprehensive assessment methodology and decision support models for SDG indicators, this system monitors the status, analyzes the trend, and evaluates over ten indicators related to SDG3, SDG4, SDG6, SDG11, SDG13, SDG14, and SDG15 in Hainan Province. It provides monitoring, assessment, and decision support services for SDG indicators to the Hainan provincial government and industry sectors.',
        app1: 'The system has the following functions of remote sensing monitoring services for engineering projects: analysis of the impact of engineering projects on protected areas, monitoring of the impact of engineering projects on the ecological environment, monitoring of the progress of construction and monitoring of socio-economic impact; management of the addition, deletion and checking of data on engineering-related projects and services, purchase of engineering-related data and sending of reports, etc.',
        app2: '研制“一带一路”重大灾害信息网络自动采集模块，包括如下功能模块：<br>(1)最新灾害事件新闻数据的实时网络爬虫抓取模块 <br>(2)国际灾害数据库历史灾害事件数据获取<br>(3)国际灾害事件数据库分析与展示。',
        app3: 'The system provides loading and display of multi-source mass data such as remote sensing images, terrain, three-dimensional models, vectors, pictures and videos, assessment of heritage sites and the change trend of heritage sites. It is applicable to the dynamic monitoring management and application of national and provincial heritage sites.',
        app4: 'The platform, including CropWatch Pro, CropWatch Explorer, CropWatch Analysis and CropWatch Bulletin, based on the latest remote sensing data, meteorological data, ground observation data, estimate crop growth, yield and other relevant information at national and global scales.',
        learnMore: 'Enter app',
        NoMobile: 'Mobile version access is not supported'
    },
    Reports: {
        Reports: 'SDGs Report: Tracking Progress on the Sustainable Development Goals',
        Description: 'Good data and clear indicators are essential for each country to assess its position on the SDGs, develop a pathway to achieve them, and track progress. Since 2016, SDSN and the Bertelsmann Foundation have published an annual global SDG index and dashboard. The methodology has been peer-reviewed (Schmidt-Traub et al., 2017) and reviewed by the European Commission Joint Research Centre (Papadimitriou, Neves, and Becker, 2019) in 2019. To better analyze national and regional contexts and improve policy relevance, SDSN has developed regional and sub-national SDG indices and dashboards in collaboration with a wide range of partners.',
        Download: 'Download ',
        online: 'Online preview',

    },
    NewList: {
        New: 'SDGs Stroy',
        Society: 'SDGs and Society',
        Science: 'Science for SDGs',
        Practices: 'Best Practices',
        Active: 'News',
        Time: 'Select time',
        Goal: 'Select SDGs targets',
        Search: 'Search',
        Reset: 'Reset',
        NoData: 'No more data available',
        More: 'More',
        LearnMore: 'Learn more',
        Share: 'Share',
        Report: 'Reports of SDGs',
        Video: 'Video of SDGs',
        SocietyDescription: 'Sustainable social development is the creation of sustainable processes that promote social well-being through understanding the needs of citizens for social life and work. The infrastructure of socio-cultural life, social amenities, citizen participation, and spaces for human and local development are indicators of the measurement of socially sustainable development processes. the integrated nature of the 2030 Agenda and its 17 Sustainable Development Goals requires greater policy coherence at the national, regional, and international levels, which can be achieved by strengthening the linkages between social science research and public policy making.',
        ScienceDescription: 'Sustainability in science and technology refers to technologies applied to sustainability activities and actions for efficiency, taking into username natural resources and promoting innovation for economic and social development, with the goal of significantly reducing environmental and ecological pollution and creating sustainable resources. Technology is shaping sustainability and achieving higher levels of productivity and efficiency, and most organizations are exploring ways to integrate new technologies and measures to advance their socio-ecological development and framework, following the goals of the Sustainable Development Goals (SDG) set by the United Nations General Assembly, which are expected to be achieved by 2030.',
        CaseDescription: "Through the Sustainable Development Practice Cases, a collection of best practices on 'how to' achieve the world's sustainable development goals and advance the 17 sustainable development goals, sharing how countries are implementing the sustainable development goals in the areas of water, energy, sustainable urban development, biodiversity and the environment, and showcasing good practices and success stories in the implementation of the sustainable development goals, the Sustainable Development Practice Cases introduce good practices from all sectors of society in promoting the 17 sustainable development goals from 2020 to the present.",
        Filter: 'Filter',
        Tpye: 'Please select the type of news',
        Ok: 'Ok',
        Canel: 'Canel',
        UnderDevelopment: 'Under development',
        Goal1: 'No poverty',
        Goal2: 'Zero Hhunger',
        Goal3: 'Good health and well-being',
        Goal4: 'Quality education',
        Goal5: 'Gerder equality',
        Goal6: 'Clean water and sanitation',
        Goal7: 'Affordable and clear energy',
        Goal8: 'Decent work and economic growth',
        Goal9: 'Industry , innovation and infrastructure',
        Goal10: 'Reduced inequalitues',
        Goal11: 'Sustainable cities and communities',
        Goal12: 'Responsible consumption and production',
        Goal13: 'Climate action',
        Goal14: 'Life below water',
        Goal15: 'Life in land',
        Goal16: 'Peace,justuce and strong institutions',
        Goal17: 'Sustainable Development Goals',
    },
    Articles: {
        Like: 'You may like',
        Other: 'Other',
        Home: 'Home',
        Details: 'Details'
    },
    PublicComponents: {
        Cookie: {
            Cookie: 'We use cookies which are essential for you to access our website and/or to provide you with our services,  allow us to measure and improve the performance of our website.',
            Accept: 'Accept all cookies',
            AcceptOnly: 'Accept only essential cookies'
        },
        ModuleTitle: {
            More: 'More'
        },
        Loading: {
            Loading: 'Loading'
        },
        Footer: {
            Nav: 'Navigation',
            DataHub: 'Data Hub',
            Society: 'SDGs and Society',
            Science: 'Science for SDGs',
            Practices: 'Best Practices',
            Knowledge: 'Knowledge Base',
            Link: 'Links',
            Link1: 'Big Earth Data Science Engineering Program',
            Link2: 'CAS Earth Cloud',
            Link3: 'International Research Center of Big Data for SDGs',
            Link4: 'SDG Big Data Platform',
            Link5: 'Computer Network Information Center',
            ContactUs: 'Contact US',
            Email: 'Email',
            Address: 'Address',
            AddressInfo: '9 Dengzhuang South Road, Haidian District, Beijing 100094',
            WeChat: 'International Research Center of Big Data for Sustainable Development Goals',
            Copyright: 'Big Earth Data Science Engineering Program , The Digital Belt and Road(DBAR) Program Beijing ',
            Copyright2: '',
            Postcode: 'Postcode',
            Phone: 'Phone'
        }
    },
    User: {
        Header: {
            //   Title: 'DBAR Big Earth Data System',
            Title: 'DBAR Big Earth Data Analysis and Decision Support System',
            Home: 'Home',
        },
        Login: {
            UserName: 'Username',
            Password: 'Password',
            TipUserName: 'Please enter username',
            TipPassword: 'Please enter password',
            ErrUserName: 'The username or password is incorrect',
            ErrPassword: 'The username or password is incorrect',
            Login: 'Login',
            Register: 'Register',
            Forget: 'Forget'
        },
        Register: {
            UserName: 'Username',
            Email: 'Email',
            Code: 'Code',
            Password: 'Password',
            ConfirmPassword: 'Confirm',
            TipUserName: 'Please enter username',
            TipEmail: 'Please enter emial',
            TipCode: 'Please enter verification code',
            TipPassword: 'Please enter password',
            TipConfirmPassword: 'Please confirm password.',
            Login: 'Login',
            Register: 'Register',
            Forget: 'Forget',
            GetCode: 'GetCode',
            OK: 'OK'
        },
        Forget: {
            UserName: 'Username',
            Email: 'Email',
            Code: ' Code',
            Password: 'Password',
            ConfirmPassword: 'Confirm ',
            TipUserName: 'Please enter username',
            TipEmail: 'Please enter emial',
            TipCode: 'Please enter verification code',
            TipPassword: 'Please enter password',
            TipConfirmPassword: 'Please confirm password.',
            Login: 'Login',
            Register: 'Register',
            Forget: 'Forget',
            GetCode: 'GetCode',
            OK: 'OK'
        }


    },
    Verification: {
        EmailRegistered: 'Email is registered',
        EmailErr: 'Email format error',
        UserNameRegistered: 'Username is registered',
        UserNameNotExist: 'Username does not exist',
        Err: 'Operation failed',
        getCode: 'Get Code',
        OK: 'Success',
        LoginErr: 'Incorrect username or password',
        LoginOk: 'Login successful'
    },

    About: {
        title: 'International Research Center of Big Data for Sustainable Development Goals',
        title_brief: 'Introduction',
        brief: 'The International Research Center of Big Data for Sustainable Development Goals (CBAS) aims to harnesses Big Earth Data to serve the UN 2030 Agenda for Sustainable Development. The Center is hosted by the Chinese Academy of Sciences (CAS), featuring multidisciplinary research related to Earth system science, social and economic sciences, as well as sustainability science. Specifically, the Center is devoted to the monitoring and evaluation of SDG indicators in the areas where Big Earth Data plays a key role, including environmental commons, urban and peri-urban development, food security and energy decarbonization.',
        title_position: 'Positioning',
        position: 'Faced with the great demand for promoting the global implementation of the SDGs, CBAS, led by TFM, aims to construct the theory, method and technical system of big data in support of SDGs, establish an open and shared Digital Earth scientific platform, lead the development of big data discipline for global sustainable development, offer comprehensive data sharing, technical support and decision support services to relevant UN agencies, its member states and China, and become an international first-class comprehensive research organization.',
        title_target: 'Objective',
        target1: 'The overall goal of CBAS is to establish a public technology platform and research institution of big data for sustainable development, which requires the combined efforts of multiple parties, including the Science Research Center of Sustainable Development, Data Information Service and Technology Innovation Center, Talent Cultivation and Training Capacity Building Center, High-end Global Think Tank for Sustainable Development, related organizations serving for the UN and member countries, to implement',
        target2: 'CBAS has been playing its role in leading research on the realization of SDGs supported by international big earth data, collaborating with the UN online platform of promoting SDGs through scientific and technological innovation, popularizing the big data approach for sustainable development in developing countries along the "Belt and Road", and speeding up the realization of SDGs driven by scientific and technological innovation.',
        title_active: 'Research Activities',
        active_title_1: 'SDG Big Earth Data platform',
        active_text_1: ' The Center will develop an SDG relevant Big Earth Data platform featuring high-performance computing, big data analysis, AI, and iCloud service. The data-driven platform is equipped to receive, process, distribute, and share Big Earth Data, and will serve as a one-stop infrastructure addressing SDG indicator-related monitoring and evaluation.',
        active_title_2: 'SDG science satellites',
        active_text_2: ' In accordance with the specific needs of SDG indicators, the Center will develop and operate SDG series science satellites and provide indicator-tailored data sources to facilitate global SDG implementation.',
        active_title_3: 'Technological and Method Research for SDG monitoring and evaluation',
        active_text_3: 'In accordance with the characteristics of SDG indicators, the Center will develop technical solutions and theoretical system driven by Big Earth Data to better measure the progress of SDGs.',
        active_title_4: 'Think tank',
        active_text_4: 'With a focus on the technology-innovation, the Center will build a think tank to address the scientific problems arising in the implementation of the UN 2030 Agenda, and therefore to support effective policymaking for a more sustainable future.',
        active_title_5: 'Education and training',
        active_text_5: 'The Center will provide professional education and training relevant to Big Earth Data for developing countries.'
    },

    Contact: {
        Name: 'International Research Center of Big Data for Sustainable Development Goals',
        Addres: 'Addres',
        Postcode: 'Postcode',
        Phone: 'Phone',
        Fax: 'Fax',
        NetWork: 'URL',
        Email: 'Email',
        AddresText: '9 Dengzhuang South Road, Haidian District, Beijing',
        PostcodeText: '100094',
        PhoneText: '+86-10-82178985',
        FaxText: '+86-10-82178980',
        NetWorkText: 'sdg.casearth.cn',
        EmailText: 'secretariat@cbas.ac.cn',

    },

    // ----------------------------------
















    login: {
        username: 'Username',
        password: 'Password',
        forget: 'Forget Password',
        login: 'Login',
        register: 'To Register',
        loginError: 'The username or password is incorrect',
        tip1: 'Please enter username',
        tip2: 'Please enter password'
    },
    register: {
        register: 'Register',
        username: 'Username',
        email: 'Email',
        code: 'Code',
        getCode: 'Get Code',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        forget: 'Forget Password',
        login: 'To Login',
        tip1: 'Please enter username',
        tip2: 'Please enter password',
        tip3: 'Please enter email',
        tip4: 'Please enter code',
        tip5: 'Please confirm password',
        checkLogin: 'The username has been registered, please enter it again',
        checkEmail: 'The email has been registered, please enter it again',
        LoginNameErr: 'The username cannot be empty',
        emailErr: 'Incorrect email format',
        usernameRegular: 'Username 4 to 16 bits (alphanumeric, underlined)',
        passwordRegular1: 'The password consists of 6-14 numbers plus letters',
        passwordRegular2: 'The password cannot be empty',
        passwordRegular3: 'The two passwords do not match',
        codeRegular: 'Please enter a verification code',
        emailRegular1: 'Incorrect email format',
        emailRegular2: 'The mailbox cannot be empty',
    },
    forget: {
        login: 'To Login',
        username: 'Username',
        email: 'Email',
        code: 'Code',
        getCode: 'Get Code',
        password: 'password',
        confirmPassword: 'Confirm Password',
        forget: 'Forget Password',
        submit: 'Submit',
        tip1: 'Please enter username',
        tip2: 'Please enter password',
        tip3: 'Please enter email',
        tip4: 'Please enter code',
        tip5: 'Please confirm password'
    },
    forgetPassword: {
        forgetPassword: 'Forget Password',
        toLogin: 'To login',
        submit: 'Submit',
        loginNameErr1: 'The username cannot be empty',
        loginNameErr2: 'Username names 4 to 16 bits (alphanumeric, underlined)',
        passwordErr1: 'The password consists of 6-14 numbers plus letters',
        passwordErr2: 'The password cannot be empty',
        passwordErr3: 'The two passwords do not match',
        codeErr: 'Please enter a verification code',
        codeErr1: 'The verification code was incorrectly entered',
        emailErr1: 'Incorrect email format',
        emailErr2: 'The mailbox cannot be empty',
        emailErr3: 'The mailbox has been registered',
        passtip: 'Password changed successfully',
    },
    // DBAR Earth Big Data System
    title: 'DBAR Big Earth Data Analysis and Decision Support System',
    knowledgeBase: {
        sdgs: 'SDGs',
        indicatorSystem: 'SDGs Indicators',
        story: 'Data and Story',
        link: 'Link',
        indicator: 'Indicator',
        series: 'Series',
        country: 'Country',
        target: 'Targets',
        progress: 'Progress and issues',
        goal: 'Goal Achievement',
        nodata: 'There is no data for this indicator country',
        selectCountry: 'Select Country',
        confirm: 'Confirm',
    },
    nav: {
        home: 'Home',
        share: 'Data Hub',
        market: 'Apps Market',
        tipPhone: 'The mobile version is not available yet, so stay tuned.'
    },
    titleList: {
        nav: 'Navigation',
        breakingNews: 'Featured News',
        socialEconomy: 'Science for SDGs',
        scientificResearch: 'Best Practices',
        practicalCase: 'SDGs and Society',
        knowledgeBase: 'Knowledgebase of SDGs ',
        language: 'Language',
        more: 'More'
    },
    SDG: {

        indicatorsVisualization: 'TerraView-SDGs',
        evaluationreport: 'Reports of SDGs',
        indicatorsDatabase: 'Knowledgebase of SDGs Indicators',


    },
    report: {
        reportSDGs: 'Reports of SDGs',
        version: 'Version'
    },
    new: {
        title: 'SDGs News',
        relatedNews: 'Related News',
        oldNews: 'Old News'
    },
    link: {
        email: 'Email: ',
        relatedLinks: "Related Links",
        link1: 'International Research Center on Big Data for Sustainable Development Goals',
        link2: 'Computer Network Information Center of Chinese Academy of Sciences',
        link3: 'Big Earth Data Science Engineering Program',
        link4: 'CAS Earth Cloud',
        link5: 'United Nations Sustainable Development',
        link6: "CAS Earth Big Data Science Project / DBAR International Science Project",
        contactUs: 'Contact us',
        address: 'Address: Room A1005, Remote Sensing Building, No. 9, Dengzhuang South Road, Haidian District, Beijing',
        Copyright: 'Copyright @  Big Earth Data Science Engineering Program / The Digital Belt and Road(DBAR) Program Beijing ICP 17072443'
    },
    cookie: {
        cookie: 'We use cookies which are essential for you to access our website and/or to provide you with our services,  allow us to measure and improve the performance of our website.',
        accept: 'ACCEPT ALL COOKIES',
        acceptOnly: 'ACCEPT ONLY ESSENTIAL COOKIES'
    },
    learnMore: 'Learn More',
    relatedNews: 'Related news',
    SDGRelatedInformation: 'SDGs related information',
    filter: 'Filters',
    SDGAttribution: 'SDGs Goal',
    dataCategory: 'Format',
    ecologicalAttributes: 'Theme Keywords',
    dataSources: 'Data Sources',
    label: 'Label',
    creationDate: 'Creation date',
    resolution: 'Resolution',
    dataItem: 'Data item',
    FireForecastingSystem: 'Fire forecasting system',
    terraViewSatEye: 'TerraView-SatEYE is an online mapping tool designed to facilitate data openness and sharing by providing governments, businesses and the public with easy access to massive amounts of spatial data.',
    terraViewFire: 'Forest fires pose dangers to people, property and wildlife, and are vital to the health of the forest.TerraView-Fire uses remote sensing satellites to detect fire points on a global scale and provides historical fire data and statistical analysis of fire events.',
    COVIDTracker: 'By collecting and sorting COVID-19 related data, the application provides a visual window to understand the global epidemic distribution and change trends from multiple dimensions, and realizes the customization and output of reports.',
    terraViewSDG: 'By collecting and sorting SDG-related data, the application provides global-scale visualization of SDG indicators, browsing of SDG indicator calculation data, comparative analysis of SDG indicators, and customization and output of visualization charts.',
    loading: {
        all: 'Completed',
        more: 'More',
        loading: 'Loading',
        loading1: 'Loading'
    },
    crumbs: {
        home: 'home'
    },
    dataShare: {
        all: "check all",
        deselectAll: 'deselect all',
        result: '1-Showing 10 results for a total of 45 results',
        update: 'date updated',
        create: 'date created',
        relevancy: 'relevancy',
        imageDatasets: 'Image Data',
        featureDatasets: 'Feature Data',
        forms: 'Forms',
        atmospheric: 'Atmospheric Properties',
        vegetationCoverage: 'Vegetation Coverage',
        ecologicalAttributes: 'Ecological Attributes',
        availableDate: 'Available Date',

        key: 'Keywords',
        spatialResolution: 'Spatial Resolution',
        sources: 'Sources',
        label: 'Label',
        dataItem: 'Data Item',
        dateCreated: 'Date Created',
        show: 'Show',
        back: 'Back',
        dataShare: 'Data Hub',
        createTime: 'Create Time',
        releaseMech: 'Release Mechanism',
        SDGsGoal: 'SDGs Goal'

    },
    info: {
        spheres: 'Spheres',
        spatialResolution: 'Spatial Resolution',
        temporalResolution: 'Temporal Resolution',
        territorialScope: 'Territorial Scope',
        sdg: 'SDGs Goal',
        createInstitutions: 'Create Institutions',
        creator: 'Creator',
        creationTime: 'Creation Time',
        dataItem: 'Data Item',
    },
    search: {
        placeholder: "Please enter search criteria",
        search: 'search'
    },
    sdgDataBase: {
        sdg: {
            title: 'The 17 Sustainable Development Goals are a blueprint for a better and more sustainable future for all.The goals set out the global challenges we face, including those related to poverty, inequality, climate, environmental degradation, prosperity, and peace and justice.These interconnected goals are designed to leave no one behind, and we must achieve each by 2030',
            GOAL1: 'NO POVERTY',
            GOAL1Value: 'Economic growth must be inclusive to provide sustainable jobs and promote equality.',
            GOAL2: 'ZERO HUNGER',
            GOAL2Value: 'The food and agriculture sector offers key solutions for development, and is central for hunger and poverty eradication.',
            GOAL3: 'GOOD HEALTH AND WELL-BEING',
            GOAL3Value: 'Ensuring healthy lives and promoting the well-being for all at all ages is essential to sustainable development.',
            GOAL4: 'QUALITY EDUCATION',
            GOAL4Value: 'Obtaining a quality education is the foundation to improving people’s lives and sustainable development.',
            GOAL5: 'GENDER EQUALITY',
            GOAL5Value: 'Gender equality is not only a fundamental human right, but a necessary foundation for a peaceful, prosperous and sustainable world.',
            GOAL6: 'CLEAN WATER AND SANITATION',
            GOAL6Value: 'Clean, accessible water for all is an essential part of the world we want to live in.',
            GOAL7: 'AFFORDABLE AND CLEAN ENERGY',
            GOAL7Value: 'Energy is central to nearly every major challenge and opportunity.',
            GOAL8: 'DECENT WORK AND ECONOMIC GROWTH',
            GOAL8Value: 'Sustainable economic growth will require societies to create the conditions that allow people to have quality jobs.',
            GOAL9: 'INDUSTRY, INNOVATION, AND INFRASTRUCTURE',
            GOAL9Value: 'Investments in infrastructure are crucial to achieving sustainable development.',
            GOAL10: 'REDUCED INEQUALITIES',
            GOAL10Value: 'To reduce inequalities, policies should be universal in principle, paying attention to the needs of disadvantaged and marginalized populations.',
            GOAL11: 'SUSTAINABLE CITIES AND COMMUNITIES',
            GOAL11Value: 'There needs to be a future in which cities provide opportunities for all, with access to basic services, energy, housing, transportation and more.',
            GOAL12: 'RESPONSIBLE CONSUMPTION AND PRODUCTION',
            GOAL12Value: 'Ensure sustainable consumption and production patterns',
            GOAL13: 'CLIMATE ACTION',
            GOAL13Value: 'Climate change is a global challenge that affects everyone, everywhere.',
            GOAL14: 'LIFE BELOW WATER',
            GOAL14Value: 'Careful management of this essential global resource is a key feature of a sustainable future.',
            GOAL15: 'LIFE ON LAND',
            GOAL15Value: 'Sustainably manage forests, combat desertification, halt and reverse land degradation, halt biodiversity loss',
            GOAL16: 'PEACE, JUSTICE AND STRONG INSTITUTIONS',
            GOAL16Value: 'Access to justice for all, and building effective, usernameable institutions at all levels.',
            GOAL17: 'PARTNERSHIPS',
            GOAL17Value: 'Revitalize the global partnership for sustainable development.',
        }
    },

}
